{
  "commonHeader": {
    "upgradeToPro": "升级",
    "learnMore": "了解更多",
    "AIProductivitySuite": {
      "title": "AI 生产力套件",
      "desc": "将充满灵感的讨论转化为令人印象深刻的成果。"
    },
    "aicForAdmin": {
      "coachMark": {
        "title": "使用 AI 管理组织账户",
        "description": "获取账户问题的智能解答，并帮助你浏览设置。",
        "terms": "使用 Zoom 测试版功能，即表示你同意 {0}",
        "termsText": "Zoom 测试版计划条款"
      },
      "diveDeeper": "深入了解",
      "shareFeedback": "在 {0} 中分享反馈",
      "askAiAdmin": "#Ask AI admin",
      "placeholder": "询问有关组织账户的问题",
      "heroInvite": "如何邀请新用户加入我的账户？",
      "heroGroups": "如何将用户分配到群组？",
      "heroRoles": "如何管理角色和权限？"
    },
    "backMainAccount": "返回主账户",
    "discoverProducts": "发现产品",
    "pricing": "定价",
    "more": "更多",
    "sidebarExpanded": "已展开",
    "sidebarCollapsed": "已收起",
    "search": "搜索",
    "users": "用户",
    "settings": "账户设置",
    "navigation": "导航",
    "clear": "清除",
    "searchPlaceholderAll": "搜索用户、账户设置或导航",
    "searchPlaceholderUsers": "搜索用户或导航",
    "searchPlaceholderSettings": "搜索账户设置或导航",
    "searchPlaceholderNav": "搜索导航",
    "searchGuide": "输入关键词开始搜索",
    "installOnDesktop": "安装到桌面",
    "downloadCenter": "下载中心",
    "getInTouch": "联系我们",
    "featuredProduct": "精选产品",
    "logo": {
      "adminCenter": "管理中心",
      "subAccount": "正在管理子账户",
      "externalAccount": "正在管理委派账户"
    }
  },
  "divisionTips": {
    "common": {
      "learnMore": "了解更多",
      "gotIt": "知道了"
    },
    "coachMark": {
      "dvsTipsTitle": "分区现已可用",
      "dvsTipsContent": "分区用于在你的账户内创建某些 Zoom 产品的多个实例。"
    }
  },
  "externalAccountTips": {
    "common": {
      "learnMore": "了解更多",
      "gotIt": "知道了"
    },
    "coachMark": {
      "extAccountTipsTitle": "管理外部账户",
      "extAccountTipsContent": "需要管理其他账户？只需发送请求——对方批准后，即可开始管理！"
    }
  },
  "feedback": {
    "dialogTitle": "提供反馈",
    "itemLableForProductArea": "产品领域",
    "itemLableForSatisfied": "您对体验的满意度如何？",
    "dissatisfied": "非常不满意",
    "satisfied": "非常满意",
    "itemLableForFeedback": "反馈",
    "placeholder": "感谢您分享的所有看法、评论和建议。",
    "btnCancel": "取消",
    "btnSubmit": "提交",
    "supportTips": "欲获得技术支持，请访问",
    "btnSupport": "支持中心。",
    "messages": {
      "success": "感谢您的反馈！",
      "productFailed": "产品领域为必填项。",
      "scoreFailed": "满意度分数为必填项。"
    },
    "products": {
      "General": "常规",
      "AI": "AI",
      "Apps": "应用",
      "Calendar": "日历",
      "Clips": "Clips",
      "ContactCenter": "联络中心",
      "Docs": "文档",
      "Huddles": "Huddles",
      "Mail": "邮件",
      "Meetings": "会议",
      "Notes": "笔记",
      "Phone": "电话",
      "Revenue": "Revenue",
      "Rooms": "会议室",
      "Scheduler": "预约助手",
      "Tasks": "任务",
      "TeamChat": "团队聊天",
      "WebinarsAndEvents": "网络研讨会和活动",
      "Whiteboard": "白板",
      "WorkflowAutomations": "工作流自动化",
      "WorkspaceReservation": "工作空间预订",
      "Workvivo": "Workvivo"
    }
  },
  "loginDisclaimer": {
    "disclaimer": "此免责声明由账户管理员创建。",
    "cancel": "取消",
    "agree": "同意"
  },
  "shared": {
    "sideMenu": {
      "personal": "个人",
      "admin": "管理员",
      "menu": "菜单",
      "pinned": "已固定",
      "pin": "固定",
      "unpin": "取消固定",
      "moveItem": "移动项目",
      "myAccount": "我的账户",
      "upgradeToPro": "升级到专业版",
      "grabbedKeyboard": "已抓取 {0}。使用上下箭头键移动，按空格或回车放下。",
      "dropped": "已放下 {0}。",
      "releasedUnchanged": "已释放 {0}，位置未更改。",
      "movedToPosition": "{0} 已移动到第 {1} 位，共 {2} 项。",
      "movedUp": "{0} 已上移，当前位置第 {1} 位，共 {2} 项。",
      "movedDown": "{0} 已下移，当前位置第 {1} 位，共 {2} 项。",
      "movedUpNew": "{0} 已上移，新位置第 {1} 位，共 {2} 项",
      "movedDownNew": "{0} 已下移，新位置第 {1} 位，共 {2} 项",
      "cannotMoveFurther": "{0} 无法继续移动。",
      "grabbedMouse": "已抓取 {0}。移动鼠标以重新定位，单击放下，按 Esc 取消。"
    },
    "item": "项目",
    "gotIt": "知道了",
    "adminCenterGuide": {
      "title": "欢迎使用全新管理中心",
      "content": "<p class=\"mgb-xs\">一个精简的中心，助你随时掌握信息并保持掌控。</p><p>管理中心将关键更新、任务和工具集中在一起，方便你配置产品、跟踪请求，并处理最重要的事项。</p>"
    }
  },
  "sign": {
    "signin_phone_bound_success": "电话号码已添加成功！现在你可以将其用于后续的登录和账户恢复。",
    "mfa_to_signin_phone_success": "{phone}现在是{email}的登录号码。",
    "login_passkey_bound_success": "通行密钥创建成功"
  },
  "userDifference": {
    "titleMap": {
      "licensed_collaboration": "以下高级管理功能仅适用于授权用户和协作用户",
      "licensed_basic": "以下高级管理功能仅适用于授权用户和基础版用户",
      "licensed": "以下高级管理功能仅适用于授权用户"
    },
    "support": "- 在账户设置和用户群组设置中受支持",
    "archive_product": {
      "title": "存档会议和网络研讨会",
      "detail": "- 当你账户中的用户加入时，会议将被存档。要使用此设置，请安装Zoom App Marketplace中的<a href=\"https://marketplace.zoom.us/apps?category=archiving\" target=\"_blank\">存档应用</a>。"
    },
    "restrict": {
      "title": "限制用户在加入会议时使用所选功能",
      "detail": "- 所选功能无法使用，即使会议主持人为会议启用这些功能也是如此。"
    },
    "meeting_integration": {
      "title": "启用会议中聊天DLP（数据丢失防护）集成",
      "detail": "- 启用后，DLP将同时适用于参会者发送的公共聊天和私聊消息。如果（内部/外部）会议的参会者正在聊天，而某一则消息违反了主持人所在组织的合规性政策，则将立即删除该消息。"
    },
    "chat_tool": {
      "title": "聊天礼仪工具",
      "detail": "- 识别共享内容中定义的关键字和文本模式，防止用户共享不当消息"
    },
    "information_barriers": {
      "title": "信息屏障",
      "detail": "- 信息屏障用于控制某些用户间的通信以符合合规性目的。可以禁止两个群组的用户之间开会和聊天，也可以限制某些用户使用特定功能（即会议中聊天、屏幕共享和文件传输）。这些限制可以防止未授权用户相互交换机密信息。"
    },
    "dashboard": {
      "title": "仪表板",
      "detail": "- 对于会议>过去的会议仪表板，某些用户仅显示3个月的数据"
    },
    "reports": {
      "title": "报告",
      "detail": "- 部分用户报告仅显示某些用户3个月的数据：免责声明报告、观众日志报告、管理员活动日志报告以及登录/退出登录报告"
    },
    "close": "关闭"
  },
  "webinarBar": {
    "body": {
      "cancel": {
        "active": {
          "webinars": {
            "admin": "你的{planName}将于{cancelDate}取消。在该日期之前，你可以重新激活你的网络研讨会许可证。{supportStartDate}至{supportEndDate}期间，你可以联系客户支持，获取现有网络研讨会的数据。{dataLossDate}之后，你将失去所有网络研讨会的数据。",
            "nonAdmin": "你的{planName}将于{cancelDate}取消。在该日期之前，你可以联系账户管理员重新激活你的网络研讨会许可证。{supportStartDate}至{supportEndDate}期间，你可以联系客户支持，获取现有网络研讨会的数据。{dataLossDate}之后，你将失去账户中所有网络研讨会的数据。"
          },
          "admin": "你的{planName}将于{cancelDate}取消。在该日期之前，你可以重新激活你的网络研讨会许可证。{supportStartDate}至{supportEndDate}期间，你可以联系客户支持，获取现有网络研讨会的{supportContent}。{dataLossDate}之后，你将失去账户中所有网络研讨会的数据。",
          "nonAdmin": "你的{planName}将于{cancelDate}取消。在该日期之前，你可以联系账户管理员重新激活你的网络研讨会许可证。{supportStartDate}至{supportEndDate}期间，你可以联系客户支持，获取现有网络研讨会的{supportContent}。{dataLossDate}之后，你将失去账户中所有网络研讨会的数据。"
        },
        "expired": {
          "admin": "你的{planName}已取消。{supportStartDate}至{supportEndDate}期间，你可以联系客户支持，获取现有网络研讨会的{supportContent}，或再次购买Zoom Webinars恢复数据访问权限。{dataLossDate}之后，你将失去账户中所有网络研讨会的数据。",
          "nonAdmin": "你的{planName}已取消。{supportStartDate}至{supportEndDate}期间，你可以联系客户支持，获取现有网络研讨会的{supportContent}，或联系账户管理员再次购买Zoom Webinars恢复数据访问权限。{dataLossDate}之后，你将失去账户中所有网络研讨会的数据。"
        }
      },
      "paused": {
        "scheduled": {
          "webinars": {
            "admin": "你的{planName}将于{pausedDate}暂停，持续{pauseDuration}。暂停期间，你只能查看现有的网络研讨会及其资产。你可以随时移除暂停，恢复订阅网络研讨会许可证。",
            "nonAdmin": "你的{planName}将于{pausedDate}暂停，持续{pauseDuration}。暂停期间，你只能查看现有的网络研讨会及其资产。你可以随时联系账户管理员移除暂停，恢复订阅网络研讨会许可证。"
          },
          "admin": "你的{planName}将于{pausedDate}暂停，持续{pauseDuration}。暂停期间，你只能查看{supportContent}。你可以随时移除暂停，恢复订阅网络研讨会许可证。",
          "nonAdmin": "你的{planName}将于{pausedDate}暂停，持续{pauseDuration}。暂停期间，你只能查看{supportContent}。你可以随时联系账户管理员移除暂停，恢复订阅网络研讨会许可证。"
        },
        "active": {
          "webinars": {
            "admin": "你的{planName}已暂停，从{pausedDate}开始，持续{pauseDuration}。暂停期间，你只能查看现有的网络研讨会。你可以随时恢复订阅网络研讨会许可证。",
            "nonAdmin": "你的{planName}已暂停，从{pausedDate}开始，持续{pauseDuration}。暂停期间，你只能查看现有的网络研讨会。你可以随时联系账户管理员，恢复订阅网络研讨会许可证。"
          },
          "admin": "你的{planName}已暂停，将持续{pauseDuration}。暂停期间，你只能查看现有网络研讨会的{supportContent}。你可以随时恢复订阅网络研讨会许可证。",
          "nonAdmin": "你的{planName}已暂停，将持续{pauseDuration}。暂停期间，你只能查看现有网络研讨会的{supportContent}。你可以随时联系账户管理员，恢复订阅网络研讨会许可证。"
        }
      },
      "multiLicense": {
        "paused": {
          "scheduled": {
            "admin": "你的{planName}许可证将于{pausedDate}暂停，持续{pauseDuration}。若要继续主持网络研讨会，请在暂停生效前为此用户分配有效的许可证。或者，也可解除暂停以继续使用此许可证。",
            "nonAdmin": "你的{planName}许可证将于{pausedDate}暂停，持续{pauseDuration}。暂停期间，你只能查看现有的网络研讨会及其资产。若要继续主持网络研讨会，请在暂停生效前联系账户管理员为你的账户分配有效的许可证。"
          },
          "active": {
            "admin": "你的{planName}许可证已暂停，从{pausedDate}开始，持续{pauseDuration}。暂停期间，你只能查看现有的网络研讨会。你可以随时恢复订阅许可证，或为你的账户分配有效许可证以继续主持网络研讨会。",
            "nonAdmin": "你的{planName}许可证已暂停，从{pausedDate}开始，持续{pauseDuration}。暂停期间，你只能查看现有的网络研讨会。若要在暂停期间主持网络研讨会，请联系账户管理员为你的账户分配有效的许可证。"
          }
        },
        "cancel": {
          "active": {
            "admin": "你的{planName}许可证将于{cancelDate}取消。若要继续主持网络研讨会，请在取消生效前重新激活你的网络研讨会许可证，或分配一个有效许可证。如果未执行任何操作，你将享有从{supportStartDate}至{supportEndDate}的宽限期可供联系客户支持以获取现有网络研讨会数据。{dataLossDate}之后，与你账户关联的所有网络研讨会数据均会永久删除。",
            "nonAdmin": "你的{planName}许可证将于{cancelDate}取消。如需继续主持网络研讨会，请在取消生效前联系账户管理员重新激活你的网络研讨会许可证或分配有效许可证。如果未执行任何操作，你将享有从{supportStartDate}至{supportEndDate}的宽限期可供联系客户支持以获取现有网络研讨会数据。{dataLossDate}之后，与你账户关联的所有网络研讨会数据均会永久删除。"
          },
          "expired": {
            "admin": "你的{planName}许可证已被取消。若要继续主持网络研讨会，请为此用户分配有效的许可证。{supportStartDate}至{supportEndDate}期间，你可以联系客户支持以获取现有网络研讨会数据。",
            "nonAdmin": "你的{planName}许可证已被取消。若要继续主持网络研讨会，请联系账户管理员为你的个人信息分配有效的许可证。{supportStartDate}至{supportEndDate}期间，请联系客户支持以获取现有网络研讨会数据。"
          }
        },
        "nonWebinars": {
          "paused": {
            "scheduled": {
              "admin": "你的{planName}许可证将于{pausedDate}暂停，持续{pauseDuration}。暂停期间，你只能查看先前网络研讨会的{supportContent}。若要继续访问网络研讨会的资产，请在暂停生效前为此用户分配有效的许可证。或者，也可解除暂停以继续使用此许可证。",
              "nonAdmin": "你的{planName}许可证将于{pausedDate}暂停，持续{pauseDuration}。暂停期间，你只能查看{supportContent}。要继续访问网络研讨会的资产，请联系账户管理员，为你的个人信息分配有效许可证。"
            },
            "active": {
              "admin": "你的{planName}已暂停，从{pausedDate}开始，持续{pauseDuration}。暂停期间，你只能查看现有网络研讨会的{supportContent}。如需继续访问网络研讨会的资产，请为你的账户分配有效的许可证。或者，你也可以随时恢复此许可证订阅。",
              "nonAdmin": "你的{planName}已暂停，从{pausedDate}开始，持续{pauseDuration}。暂停期间，你只能查看现有网络研讨会的{supportContent}。若要在暂停期间主持网络研讨会，请联系账户管理员为你的账户分配有效的许可证。"
            }
          },
          "cancel": {
            "active": {
              "admin": "你的{planName}将于{cancelDate}取消。若要继续主持网络研讨会，请在取消生效前为你的账户分配有效的许可证。你可以在{cancelDate}之前重新激活此许可证。{supportStartDate}至{supportEndDate}期间，你可以联系客户支持以获取现有网络研讨会的{supportContent}。",
              "nonAdmin": "你的{planName}许可证将于{cancelDate}取消。若要继续主持网络研讨会，请在取消生效前联系账户管理员重新激活网络研讨会许可证或分配有效许可证。如果未采取任何操作，你将有一个宽限期（{supportStartDate}至{supportEndDate}），可联系客户支持获取现有网络研讨会的{supportContent}。{dataLossDate}之后，与你账户关联的所有网络研讨会数据将被永久删除。"
            },
            "expired": {
              "admin": "你的{planName}许可证已被取消。若要继续主持网络研讨会，请为此用户分配有效的许可证。{supportStartDate}至{supportEndDate}期间，请联系客户支持以获取现有网络研讨会的{supportContent}。",
              "nonAdmin": "你的{planName}许可证已被取消。若要继续主持网络研讨会，请联系账户管理员为你的个人信息分配有效的许可证。{supportStartDate}至{supportEndDate}期间，请联系客户支持以获取现有网络研讨会的{supportContent}。"
            }
          }
        }
      }
    },
    "supportContent": {
      "cancel": {
        "webinars": "数据",
        "recordingsAndTranscripts": "录制文件和转写文字",
        "reports": "报告",
        "summaries": "摘要",
        "dashboard": "仪表板"
      },
      "paused": {
        "scheduled": {
          "recordingsAndTranscripts": "之前网络研讨会的录制文件和转写文字",
          "reports": "之前网络研讨会的报告",
          "summaries": "之前网络研讨会的摘要",
          "dashboard": "之前网络研讨会的仪表板",
          "webinars": ""
        }
      }
    },
    "reactivatePlan": "重新激活套餐",
    "purchasePlan": "购买套餐",
    "removePause": "移除暂停",
    "resumeSubscription": "恢复订阅",
    "month": "个月",
    "months": "个月",
    "assignLicense": "分配许可证"
  },
  "zccRenameTips": {
    "common": {
      "gotIt": "知道了"
    },
    "coachMark": {
      "tipsTitle": "通讯录将更名为客户目录",
      "tipsContent": "在 2026 年 10 月的版本中，我们将“通讯录”更名为“客户目录”，以更准确地反映其用途。所有现有功能、权限和工作流程将保持不变——你仍可像现在一样管理客户列表（通讯录）和联系人。"
    }
  },
  "zoomPrivacy": {
    "agreeMain": "我们正在更新条款和政策",
    "agreeSub": "如果继续使用Zoom，即表示你接受更新后的<a href=\"https://www.zoom.us/zh-cn/terms.html\" target=\"_blank\">服务条款</a>和<a href=\"https://www.zoom.us/zh-cn/privacy.html\" target=\"_blank\">隐私政策</a>。",
    "continue": "继续"
  },
  "adminMenu": {
    "adminMenu": {
      "backMainAccount": "返回主账户",
      "backLinkedAccount": "返回关联账户",
      "backMyAccount": "返回我的账户",
      "myAccount": "我的账户"
    }
  },
  "aicGuide": {
    "onboarding": {
      "title": "定制 AI 伴侣现已可用于你的账户",
      "desc": "以下是你可以在账户中使用的部分定制 AI 伴侣功能：",
      "studioTitle": "AI Studio",
      "studioDesc": "为你的组织定制 AI 伴侣体验。",
      "integrationsTitle": "第三方集成",
      "integrationsDesc": "利用第三方应用简化工作流程。",
      "clipsTitle": "Zoom Clips 自定义虚拟形象",
      "clipsDesc": "允许用户个性化 AI 虚拟形象，用于其剪辑。"
    },
    "coachMark": {
      "licenseTitle": "你有 {0} 个定制 AI 伴侣许可证待分配",
      "licenseDesc": "请在<b>用户管理</b>下分配这些许可证，以便用户开始使用高级 AI 伴侣功能。",
      "settingTitle": "查看账户的定制 AI 伴侣设置",
      "settingDesc": "在<b>账户设置</b>下为每项定制 AI 功能配置设置。<a href=\"/account/setting?tab=aicompanion\">前往设置</a>",
      "groupSettingTitle": "查看群组的定制 AI 设置",
      "groupSettingDesc": "在<b>群组设置</b>下为每项定制 AI 功能配置设置。<a href=\"/account/group\">前往设置</a>"
    },
    "common": {
      "learnMore": "了解更多",
      "quickTour": "快速导览",
      "remindLater": "稍后提醒我",
      "dismiss": "关闭",
      "next": "下一步",
      "back": "返回",
      "gotIt": "知道了",
      "goToSetting": "前往设置"
    },
    "aiPanelToast": "开启<b>Zoom Workplace 中的 AI 面板</b>设置，开始使用全部定制 AI 伴侣功能。"
  },
  "coachMark": {
    "coachMark": {
      "gotIt": "知道了",
      "next": "下一步",
      "remindMeLater": "稍后提醒我",
      "waffleMenuTitle": "欢迎使用全新 Zoom 网页体验",
      "waffleMenuDesc": "通过全新的<b>产品菜单</b>，随时随地访问 Zoom 产品。",
      "profileMenuTitle": "我的账户",
      "profileMenuDesc": "在<b>我的账户</b>中查找你的个人资料和个人设置。",
      "personalTitle": "获取你所需的一切",
      "personalDesc": "<b>我的账户</b>包含你的个人资料、设置、会议转写文字等。",
      "adminCenterTitle": "在管理中心查找组织设置",
      "adminCenterDesc": "全新<b>管理中心</b>可让你为整个组织配置产品并调整设置。",
      "adminMenuForTitle": "像专业人士一样使用管理中心",
      "adminMenuForAccountSettings": "<b>设置</b>可让你访问组织中所有人的默认产品设置。",
      "adminMenuForContentManagementItem": "你可以在<b>内容管理</b>中管理所有用户生成的内容。",
      "adminMenuForConfigureProductsItem": "<b>产品配置</b>可让你为产品完成设置和管理员任务。",
      "adminMenuForNoItems": "全新管理中心可让你更轻松地访问和管理账户设置与产品。你还可以将常用项目固定，以便更快访问。",
      "tryNewExperience": "试用新体验",
      "tryNewExperienceDetail": "试试看！你随时可以返回此经典体验。",
      "tryNewExperienceTitle": "Zoom 网页版全新外观！"
    }
  },
  "footerCopyright": {
    "copyright": "版权所有 {'@'}{0} Zoom Communications, Inc. 保留所有权利。",
    "terms": "条款",
    "privacy": "隐私",
    "trust_center": "信任中心",
    "acceptable_use_guidelines": "可接受使用准则",
    "legal": "法律",
    "do_not_sell_my_personal_information": "你的隐私选择",
    "cookie_preferences": "Cookie 偏好设置",
    "pricing": "套餐和定价",
    "feedback": "反馈",
    "contact_us": "联系我们"
  },
  "termChange": {
    "changeTerm": {
      "title": "续订期限变更协议",
      "quoteNumbers": "已修改的订单表格 - {0}",
      "content1": "接受本条款即表示客户同意修改 Zoom Communications, Inc.（“Zoom”）与客户之间所有订单表格的现有订阅续订期限，将承诺期限从按月续订期限变更为{0}。作为该承诺的对价，Zoom 同意在第一个新续订期限内维持客户的当前定价。",
      "content2": "客户理解，一旦客户点击下方“我接受”，新的续订期限 {0} 即告适用，且该新续订期限将于客户当前按月续订期限结束后的次日开始。此新续订期限将适用于目前与 Zoom 有效的所有订单表格，且这些订单表格项下所有未来续订期限均采用相同的续订期限长度。",
      "content3": "客户确认，本次仅变更续订期限，目前与 Zoom 有效的每份订单表格的所有其他条款和条件均保持不变，并按其条款继续完全有效。",
      "content4": "你进一步同意，此为客户与 Zoom 之间的合同承诺。",
      "agreementText": "点击“我接受”，即表示你证明自己有权代表客户作出此项变更，且客户同意上述条款和条件。",
      "IDecline": "我拒绝",
      "IAccept": "我接受"
    },
    "unableToChangeTerm": {
      "title": "无法更改续订期限",
      "content": "你的账户不符合更新续订期限的条件。如果这是错误，请<a target=\"_blank\" href=\"{0}\">联系我们</a>。",
      "acceptedTitle": "续订期限已延长",
      "acceptedContent": "你此前已接受续订条款，无需再采取任何操作。",
      "GotIt": "知道了"
    },
    "termLengthUpdated": "续订期限长度已更新为 {0} 个月。",
    "termLengthUnchanged": "期限长度未更改。",
    "errorInfo": "发生服务器错误。请重试。",
    "x12MonthTerm": "十二（12）个月期限",
    "x24MonthTerm": "二十四（24）个月期限",
    "x12MonthTermPlural": "十二（12）个月",
    "x24MonthTermPlural": "二十四（24）个月"
  },
  "commonNoticeBars": {
    "adminReminder": {
      "content": "你的账户计划于 {0} 更新到<a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\">全新 Zoom 网页体验</a>。",
      "action": "<a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\" style=\"line-height: 20px;\">查看更新时间</a>"
    },
    "completed": {
      "content": "全新 Zoom 网页体验现已对账户中的所有用户生效。用户下次登录时将看到更新后的界面。"
    }
  }
}
